import {
    RESELLERS_RECEIVE,
    RESELLERS_LOADING,
    RESELLERS_LOAD_ERROR,
  } from '../constants';
  
  const DEFAULT_STATE = {
    resellers: [],
    googleMapsApiKey: '',
    errorMessage: '',
    loading: false,
  };
  
  export const resellers = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
      case RESELLERS_RECEIVE:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          loading: false,
        };
      case RESELLERS_LOAD_ERROR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          loading: false,
        };
      case RESELLERS_LOADING:
        return {
          ...state,
          loading: action.payload,
        };
      default:
        return state;
    }
  };
  